<template>
    <div class="main">
        <c-panel>
            <form-aee :paramId="$route.params.id" v-on:onSubmit="onSubmit"></form-aee>
        </c-panel>
    </div>
</template>

<script>
import formAee from './form'

export default {
    methods: {
        onSubmit () {
            this.$router.push('/admin/pedagogico/aee')
        }
    },
    components: { formAee }
}
</script>
